// extracted by mini-css-extract-plugin
export default {"error":"LAL6Bj98Uy0iggzNskTb","spinner":"vqhsSoz99o3T3XlfJRqF"};